/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAiBooklet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M18 6.388h2v16H4V6.667L18 2zm-12 14h1.1a5.004 5.004 0 0 1 2.102-3.146 3.993 3.993 0 0 1-1.076-1.854H7v-2h1.126a4.002 4.002 0 0 1 7.748 0H17v2h-1.126a3.992 3.992 0 0 1-1.077 1.854 5.004 5.004 0 0 1 2.102 3.146H18v-12H6zm6-2a2.998 2.998 0 0 0-2.826 2h5.652a2.998 2.998 0 0 0-2.826-2zm0-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-.839-6H16V4.774z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAiBooklet as AiBooklet };
